<template>
  <HPopup class="h-purchase-request-popup"
          ref="popup"
          v-show="visible">
    <div class="h-sell-body">
      <div class="sell-header">交易所老板说道：这里收购商品，需要支付100金币/条/天。</div>

      <div class="mt-10 flex items-center h-outer-border around-4 bw2 bz0 h-bg brown-2">
        <span class="color-gold-1 mr-5">选择收购物品：</span>
        <HSelect style="width: 30%; margin-right: 10px;"
                 class=""
                 ref="townSelect"
                 placeholder="选择物品类型"
                 size="large"
                 :options="LEVEL_1_DATA"
                 v-model="level_value_1"
                 optionsMaxHeight="310px"
                 @input="handleSelectLevel1">
        </HSelect>
        <HSelect style="width: 30%;"
                 class=""
                 ref="townSelect"
                 placeholder="选择物品"
                 size="large"
                 :options="LEVEL_2_DATA"
                 v-model="form.artifactId"
                 optionsMaxHeight="310px">
        </HSelect>
      </div>

      <div class="sell-form h-outer-border around-4 bw2 bz0 h-bg brown-2">
        <div class="icon" style="width: 48px; height: 48px;">
          <img v-if="form.artifactId" :src="iconURL" style="width: 48px; height: 48px;" alt="artifact icon">
        </div>

        <div class="sell-form-item sell-gold">
          <p class="ls-1">收购价</p>
          <div>
            <input type="text" maxlength="9" spellcheck="false" placeholder="收购价"
                   :value="form.gold" @blur="handleFixGold">
          </div>
        </div>

        <div class="sell-form-item sell-amount">
          <p class="ls-1">收购数量</p>
          <div>
            <HInputNumber :min="1" :max="maxAmount" v-model="form.amount"></HInputNumber>
          </div>
        </div>

        <div class="sell-form-item sell-amount" style="width: 80px;">
          <p class="ls-1">收购天数</p>
          <div>
            <input type="text" maxlength="2" spellcheck="false" placeholder="寄卖天数"
                   :value="form.dayNum" @blur="handleFixDayNum">
          </div>
        </div>

        <div class="sell-form-item sell-amount" style="width: 80px;">
          <p class="ls-1">手续费</p>
          <div>
            <input type="text" spellcheck="false" readonly placeholder="0" :value="sellCost">
          </div>
        </div>

        <div class="sell-form-item sell-amount">
          <p class="ls-1">预缴费</p>
          <div>
            <input type="text" spellcheck="false" readonly placeholder="0" :value="depositCost">
          </div>
        </div>

        <div class="sell-form-item sell-amount">
          <p class="ls-1">总计花费</p>
          <div>
            <input type="text" spellcheck="false" readonly placeholder="0" :value="totalCost">
          </div>
        </div>

      </div>
    </div>

    <footer class="flex">
      <button v-click-sound-button
              class="h-btn normal btn-border"
              :disabled="submitDisable"
              @click="handleSubmit">
        收购
      </button>
      <button v-click-sound-button
              class="h-btn normal btn-border"
              @click="handleClose">
        取消
      </button>
    </footer>
  </HPopup>
</template>

<script>
  import HPopup from '@/components/h-popup/index.vue'
  import HArtifact from '@/components/h-artifact/index'
  import HInputNumber from '@/components/h-input-number/index'
  import HSelect from '@/components/h-select'
  import { mapActions, mapGetters } from 'vuex';
  import API from '@js/api'

  const LEVEL_1_DATA = [
    { text: '资源/材料', value: 1, },
    { text: '宝箱/道具', value: 2, },
    { text: '装备/宝物', value: 3, },
    { text: '装备图纸', value: 4, },
    { text: '声望物品', value: 5, },
  ]
  const itemsMap = {
    // 资源
    1: [
      { text: '木材车', value: 401, },
      { text: '矿石车', value: 402, },
      { text: '水晶矿车', value: 403, },
      { text: '宝石矿车', value: 404, },
      { text: '水银矿车', value: 405, },
      { text: '硫磺矿车', value: 406, },

      { text: '大型木材车', value: 411, },
      { text: '大型矿石车', value: 412, },
      { text: '大型水晶矿车', value: 413, },
      { text: '大型宝石矿车', value: 414, },
      { text: '大型水银矿车', value: 415, },
      { text: '大型硫磺矿车', value: 416, },

      { text: '寒铁', value: 191, },
      { text: '赤铜', value: 192, },
      { text: '星砂', value: 193, },
      { text: '灵魂晶石', value: 194, },
    ].map((item) => {
      return {
        ...item,
        icon: `${process.env.VUE_APP_OSS_URL}/img/artifact/ARTIFACT${item.value}.png`
      }
    }),
    2: [
      { text: '经验碎片', value: 408, },
      { text: '经验碎片', value: 417, },
      { text: '经验球', value: 420, },
      { text: '鼓舞药剂', value: 419, },
      { text: '鼓舞药剂(大)', value: 423, },

      { text: '勇气宝箱', value: 501, },
      { text: '勇士资源箱', value: 502, },
      { text: '竞技宝箱', value: 505, },
      { text: '稀有资源袋', value: 506, },
      { text: '狮鹫宝箱', value: 507, },
      { text: '狮鹫宝箱', value: 510, },
      { text: '神秘图纸袋', value: 511, },
      { text: '墓室宝箱', value: 512, },
    ].map((item) => {
      return {
        ...item,
        icon: `${process.env.VUE_APP_OSS_URL}/img/artifact/ARTIFACT${item.value}.png`
      }
    }),
    3: [
      { text: '领袖披风', value: 1401, },
      { text: '骨牙饰物', value: 1501, },
      { text: '舒适皮靴', value: 1801, },
      { text: '战意指环', value: 2101, },
      { text: '冥想戒指', value: 2151, },
      { text: '幸运指环', value: 2201, },

      { text: '时效坐骑', value: 1601, },
      { text: '时效坐骑', value: 1602, },
      { text: '时效坐骑', value: 1603, },
      { text: '时效坐骑', value: 1604, },

      { text: '火灵球', value: 2800, },
      { text: '水灵球', value: 2810, },
      { text: '气灵球', value: 2820, },
      { text: '土灵球', value: 2830, },
      { text: '幸运苜蓿', value: 2840, },
      { text: '专注之眼', value: 2850, },
      { text: '幻影神弓', value: 2860, },
    ].map((item) => {
      return {
        ...item,
        icon: `${process.env.VUE_APP_OSS_URL}/img/artifact/ARTIFACT${item.value}.png`
      }
    }),
    4: [
      {
        text: '人马战斧图纸', value: 111
      },
      {
        text: '矮人王盾图纸', value: 112
      },
      {
        text: '神兽之冠图纸', value: 113
      },
      {
        text: '藤木甲图纸', value: 114
      },
      {
        text: '冷静挂件图纸', value: 115
      },
      {
        text: '星轴杖图纸', value: 116
      },
      {
        text: '守护铠甲图纸', value: 117
      },
      {
        text: '龙眼之戒图纸', value: 118
      },
      {
        text: '杀戮者之戒图纸', value: 119
      },
      {
        text: '侵蚀者之戒图纸', value: 120
      },
      {
        text: '海洋之心图纸', value: 121
      },
      {
        text: '毒巫面具图纸', value: 131
      },
      {
        text: '法王面具图纸', value: 132
      },
      {
        text: '智慧之冠图纸', value: 133
      },
      {
        text: '暗骑士盔图纸', value: 134
      },
      {
        text: '混沌之冠图纸', value: 135
      },
      {
        text: '鬼影盾图纸', value: 141
      },
      {
        text: '磐音之盾图纸', value: 142
      },
      {
        text: '狼人王盾图纸', value: 143
      },
      {
        text: '狂魔盾图纸', value: 144
      },
      {
        text: '狼人连枷图纸', value: 151
      },
      {
        text: '厄运之刃图纸', value: 152
      },
      {
        text: '荆棘之刃图纸', value: 153
      },
      {
        text: '恶咒之杖图纸', value: 155
      },
      {
        text: '荣耀之杖图纸', value: 156
      },
      {
        text: '圣祭神话图纸', value: 157
      },
      {
        text: '战神印记图纸', value: 161
      },
      {
        text: '荣耀之心图纸', value: 162
      },
      {
        text: '女神之愿图纸', value: 165
      },
      {
        text: '月神坠饰图纸', value: 166
      },
      {
        text: '复仇者之戒图纸', value: 171
      },
      {
        text: '亡者之怒图纸', value: 172
      },
      {
        text: '默契之戒图纸', value: 175
      },
      {
        text: '魔魂光华图纸', value: 176
      },
      {
        text: '祝福之戒图纸', value: 181
      },
      {
        text: '仙女指环图纸', value: 182
      },
      {
        text: '欲望之曲图纸', value: 183
      },
      {
        text: '曙光之戒图纸', value: 184
      },
      {
        text: '紫金苜蓿图纸', value: 185
      },
      {
        text: '十字军铠甲图纸', value: 801
      },
      {
        text: '寒冰甲图纸', value: 802
      },
      {
        text: '巨人战甲图纸', value: 803
      },
      {
        text: '术士袍图纸', value: 805
      },
      {
        text: '风暴法袍图纸', value: 806
      },
      {
        text: '黄金甲图纸', value: 807
      },
      {
        text: '护卫之靴图纸', value: 811
      },
      {
        text: '骑士之靴图纸', value: 813
      },
      {
        text: '游侠之靴图纸', value: 814
      },
      {
        text: '清风之拂图纸', value: 815
      },
      {
        text: '辉煌之靴图纸', value: 816
      },
      {
        text: '暗夜之影图纸', value: 821
      },
      {
        text: '守护披风图纸', value: 823
      },
      {
        text: '风暴战披图纸', value: 824
      },
      {
        text: '泽达的冥想图纸', value: 825
      },
      {
        text: '黑暗披风图纸', value: 826
      }
    ].map((item) => {
      return {
        ...item,
        icon: `${process.env.VUE_APP_OSS_URL}/img/artifact/ARTIFACT${item.value}.png`
      }
    }),
    5: [
      { text: '神耀权杖', value: 440, },
      { text: '月辉石', value: 441, },
      { text: '圣导师徽章', value: 442, },
      { text: '杀戮之心', value: 443, },
      { text: '幽冥雕饰', value: 444, },
      { text: '大地之魂', value: 445, },
      { text: '战神图腾', value: 446, },
      { text: '恐惧挂件', value: 447, },
      { text: '烈火纹章', value: 448, },
      { text: '风暴号角', value: 449, },
    ].map((item) => {
      return {
        ...item,
        icon: `${process.env.VUE_APP_OSS_URL}/img/artifact/ARTIFACT${item.value}.png`
      }
    }),
  }

  export default {
    name: 'sell-popup',

    components: {
      HPopup,
      HArtifact,
      HInputNumber,
      HSelect,
    },

    data () {
      return {
        LEVEL_1_DATA,
        level_value_1: '',
        LEVEL_2_DATA: [],
        form: {
          gold: 0,
          amount: 1,
          dayNum: 1,
          artifactId: null,
        },
        submitLoading: false,
      }
    },

    props: {
      visible: {
        type: Boolean,
        default: true
      },
      zIndex: {
        type: Number,
        default: 1000
      },
    },

    computed: {
      ...mapGetters('hero', [
        'gold'
      ]),

      sellCost () {
        return 100 * this.form.dayNum || 0
      },

      // 押金
      depositCost () {
        return +(this.form.gold * this.form.amount).toFixed(0) || 0
      },

      totalCost () {
        return +(this.sellCost + this.depositCost).toFixed(0)
      },

      submitDisable () {
        const { gold, amount, dayNum } = this.form
        return !gold || !amount || !dayNum
      },

      iconURL () {
        if (!this.form.artifactId) {
          return null
        }
        return `${process.env.VUE_APP_OSS_URL}/img/artifact/ARTIFACT${this.form.artifactId}.png`
      },

      maxAmount () {
        if (this.form.artifactId >= 1000 && this.form.artifactId <= 3000) {
          return 1
        }
        return 1000
      },
    },

    mounted () {
    },

    methods: {
      ...mapActions('hero', [
        'getGold',
      ]),

      handleClose () {
        this.$emit('close')
      },

      handleSelectLevel1 () {
        this.form.gold = 0
        this.form.amount = 1
        this.form.dayNum = 1
        this.form.artifactId = ''

        if (!this.level_value_1) {
          this.LEVEL_2_DATA = []
          return
        }
        this.LEVEL_2_DATA = JSON.parse(JSON.stringify(itemsMap[this.level_value_1]))
      },

      handleFixGold (e) {
        let v = e.target.value
        if (!/^\d+$/.test(v)) {
          v = +(v).replace(/[^\d]/g, '') || 0
        }
        this.form.gold = Math.max(+v, 0)
        this.$forceUpdate()
      },

      handleFixAmount (e) {
        let v = e.target.value
        if (!/^\d+$/.test(v)) {
          v = +(v).replace(/[^\d]/g, '') || 0
        }
        this.form.amount = Math.max(+v, 0)
        this.$forceUpdate()
      },

      handleFixDayNum (e) {
        let v = e.target.value
        if (!/^\d+$/.test(v)) {
          v = +(v).replace(/[^\d]/g, '') || 0
        }
        this.form.dayNum = Math.max(+v, 0)
        this.$forceUpdate()
      },

      async handleSubmit () {
        try {
          if (this.submitLoading) {
            return
          }
          this.submitLoading = true
          if (this.gold < this.totalCost) {
            this.$message('你的金币不足')
            return
          }
          if (this.form.gold <= 0) {
            this.$message('未设置有效售价')
            return
          }
          if (this.form.amount <= 0) {
            this.$message('未设置有效数量')
            return
          }
          if (this.form.amount > 9999) {
            this.$message('数量超过最大值')
            return
          }
          if (this.form.dayNum <= 0) {
            this.$message('未设置有效天数')
            return
          }
          if (this.form.dayNum > 99) {
            this.$message('天数超过最大值')
            return
          }

          await API.market.publishRequestPurchase({
            ...this.form,
          })
          this.$emit('close')
          this.$emit('refresh')
          this.$message('收购已发布')
          this.getGold()
        } catch (err) {
          this.$message(err)
        } finally {
          this.submitLoading = false
        }
      },

    },
  }
</script>

<style lang="stylus" scoped>
  .h-sell-body
    padding 10px
    width 700px

  footer
    margin-top 30px
    justify-content space-evenly

  .sell-header
    padding 10px 0
    line-height 16px
    font-size 12px
    letter-spacing 1px
    text-align center
    goldText1()

  .sell-form
    position relative
    display flex
    margin 10px 0
    padding 3px
    justify-content space-between

  .h-artifact
    flex-shrink 0

  .sell-form-item
    position relative
    display flex
    flex-direction column
    justify-content space-evenly
    width 120px
    flex-shrink 0
    padding 2px 5px
    font-size 12px
    text-align center
    goldText1()
    input
      height 24px
      border 1px solid rgba(255, 255, 255, 0.25)
      line-height 22px
      font-size 12px
      letter-spacing 1px
      border-radius 2px
      background-color rgba(0, 0, 0, 0.25)

</style>
